<script setup>
  import { onMounted } from 'vue'
  import ReservationStep from './ReservationStep.vue';
  import RecommendationStep from './RecommendationStep.vue';
  import store from '../store';

  onMounted(() => {
    store.setStep('reservation');
  });
</script>

<template>
  <ReservationStep v-if="store.step === 'reservation'" />
  <RecommendationStep v-if="store.step === 'recommendation'" />
</template>

